import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import UsagePage from '@/usage/pages/usage';

export const Route = createFileRoute('/usage/electric')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: ElectricUsageRoute,
  staticData: {
    headerSection: 'usage'
  }
});

function ElectricUsageRoute() {
  return <UsagePage accountType="electric" unit="kwh"/>;
}
